<template>
  <div :class="'md-layout'">
    <md-card>
      <md-card-content>
        <div :class="'md-layout'">
          <div :class="'md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-33 md-large-size-33'">
            <md-field>
              <label>Fiscal Year</label>
              <md-select v-model="fiscal_year" md-dense>
                <md-option v-for="(year, idx) in fiscalYears" :key="idx" :value="year">
                  {{ year }}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <div :class="'md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-33 md-large-size-33'">
            <md-field>
              <label>Risk and Quality Review type</label>
              <md-select v-model="rqr_type" md-dense>
                <md-option :value="code" :key="code" v-for="(type, code) in rqrTypesMap">
                  {{ type }}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <div :class="'md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-33 md-large-size-33'">
            <md-field>
              <label>Review Reference</label>
              <md-select v-model="reference" md-dense>
                <md-option v-for="(rf, idx) in references" :key="idx" :value="rf.id">
                  {{ rf.reference }}
                </md-option>
              </md-select>
            </md-field>
          </div>
        </div>
      </md-card-content>
    </md-card>

    <md-divider></md-divider>
    <div :class="'md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25'">
      <stats-card header-color="danger">
        <template slot="header">
          <div :class="'card-icon'">
            <md-icon>warning</md-icon>
          </div>
          <p :class="'category'">Pending Reviews</p>
          <h3 :class="'title'">
            <span v-if="!isLoading">{{ pending }}</span>
          </h3>
        </template>
        <template slot="footer">
          <div :class="'stats'" :style="'cursor: pointer'" @click="goToReviews('pending')">
            <md-icon>search</md-icon>
            Show pending
          </div>
        </template>
      </stats-card>
    </div>
    <div :class="'md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25'">
      <stats-card header-color="green">
        <template slot="header">
          <div :class="'card-icon'">
            <md-icon>done</md-icon>
          </div>
          <p :class="'category'">Completed Reviews</p>
          <h3 :class="'title'">
            <span v-if="!isLoading">{{ completed }}</span>
          </h3>
        </template>
        <template slot="footer">
          <div :class="'stats'" :style="'cursor: pointer'" @click="goToReviews('completed')">
            <md-icon>search</md-icon>
            Show completed
          </div>
        </template>
      </stats-card>
    </div>

    <div :class="'md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25'"
      v-if="(isAdmin && currentProfile === 'admin') || isAudit || isAdminTI">
      <stats-card header-color="danger">
        <template slot="header">
          <div :class="'card-icon'">
            <md-icon>warning</md-icon>
          </div>
          <p :class="'category'">Pending Action Plans</p>
          <h3 :class="'title'" @click="goToActionPlans('pending')">
            <span :style="'cursor: pointer;'">{{ actionPlans.pending }}</span>
          </h3>
        </template>
        <template slot="footer">
          <div :class="'stats'" :style="'cursor: pointer'" @click="goToActionPlans('pending')">
            <md-icon>search</md-icon>
            Show pending
          </div>
        </template>
      </stats-card>
    </div>
    <div :class="'md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25'"
      v-if="(isAdmin && currentProfile === 'admin') || isAudit || isAdminTI">
      <stats-card header-color="green">
        <template slot="header">
          <div :class="'card-icon'">
            <md-icon>done</md-icon>
          </div>
          <p :class="'category'">Finished Action Plans</p>
          <h3 :class="'title'" @click="goToActionPlans('finished')">
            <span :style="'cursor: pointer'">{{ actionPlans.completed }}</span>
          </h3>
        </template>
        <template slot="footer">
          <div :class="'stats'" :style="'cursor: pointer'" @click="goToActionPlans('finished')">
            <md-icon>search</md-icon>
            Show finished
          </div>
        </template>
      </stats-card>
    </div>

    <div :class="'md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100'">
      <admin v-if="!isLoading" :barChartData="barChartGraphData" :overallGraphData="overallGraphData"
        :standardGraphData="standardGraphData">
      </admin>
    </div>
  </div>
</template>

<script>
import { StatsCard, ChartCard } from "@/components";
import Admin from "./Shared/Dashboard/Admin.vue";
import * as utils from "@/utils"
import { rqrTypesMap } from "@/filters/rqrType";
import rqrTypeEnum from "@/enums/rqrType"

export default {
  components: {
    StatsCard,
    ChartCard,
    Admin,
  },

  data() {
    return {
      isLoading: true,
      pending: 0,
      completed: 0,
      fiscal_year: new Date().getFullYear(),
      rqr_type: rqrTypeEnum.COMPLICE,
      reference: "",
      references: [],
      rqrTypesMap,
      actionPlans: {
        pending: 0,
        completed: 0,
      },
      overallGraphData: {
        labels: ["Compliant", "Adequate with exception", "Unsatisfactory"],
        datasetTitle: "Overall",
        data: [0, 0, 0],
      },
      standardGraphData: {
        labels: ["Compliant", "Adequate with exception", "Unsatisfactory"],
        datasetTitle: "Standard",
        data: [0, 0, 0],
      },
      barChartGraphData: {
        datasets: [
          {
            label: "Compliant",
            data: [0, 0, 0, 0, 0, 0, 0, 0],
            backgroundColor: "rgb(132,204,135)",
          },
          {
            label: "Adequate with exception",
            data: [0, 0, 0, 0, 0, 0, 0, 0],
            backgroundColor: "rgb(255,245,157)",
          },
          {
            label: "Unsatisfactory",
            data: [0, 0, 0, 0, 0, 0, 0, 0],
            backgroundColor: "rgb(255,162,132)",
          },
        ],
      },
    };
  },

  created() {
    if (!this.canViewDashboard) {
      this.$router.push({ name: "Reviews" });
      this.$toast.show(
        "Only admins, reviewers and RQR leaders can access dashboard"
      );
      return;
    }

    this.getDashboard();
    this.getReferences();
  },

  computed: {
    canViewDashboard() {
      return this.isAdmin || this.isReviewer || this.isRQRLeader || this.isAdminTI() || this.isAudit()
        ? true : false;
    },

    currentProfile() {
      return this.$store.state.currentProfile;
    },

    fiscalYears() {
      return utils.getFiscalYears();
    },

    isAdmin() {
      return this.$store.getters.isAdmin;
    },

    isAdminTI() {
      return this.$store.state.currentProfile === "adminTi" ? true : false;
    },

    isAudit() {
      return this.$store.state.currentProfile === "audit" ? true : false;
    },

    isReviewer() {
      return this.$store.state.currentProfile === "reviewer" ? true : false;
    },

    isRQRLeader() {
      return this.$store.state.currentProfile === "rqr_leader" ? true : false;
    },

    labels() {
      if (this.rqr_type == rqrTypeEnum.COMPLICE) {
        return [
          "Clients",
          "Independence",
          "Engagement",
          "Higher risk",
          "Contracting",
          "Deliverables",
          "Documentation",
          "Review",
        ];
      } else if (this.rqr_type == 4) {
        return [
          "Client",
          "Contract",
          "Value Proposition",
          "Talent",
          "Delivery",
          "Finance",
        ];
      } else {
        return [
          "Scope",
          "Stakeholders",
          "Governance",
          "Benefits",
          "Managed Risks",
          "Financing",
          "Delivery",
          "Active Quality",
          "Agile control",
          "Integrated suppliers",
          "High performing teams",
          "Embedded assurance",
        ];
      }
    },
  },

  watch: {
    fiscal_year: function () {
      this.getDashboard();
    },
    rqr_type: function () {
      this.getDashboard();
    },
    reference: function () {
      this.getDashboard();
    },
    currentProfile: function () {
      this.getDashboard();
    },
    "$store.state.currentProfile"() {
      if (!this.canViewDashboard) {
        this.$router.push({ name: "Reviews" });
        this.$toast.show(
          "Only admins, reviewers and RQR leaders can access dashboard"
        );

        return;
      }
    },
  },

  methods: {
    clearStandardBarChart() {
      if (this.rqr_type == 4) {
        // In Flight Review tem apenas 6 seções
        this.barChartGraphData.datasets[0].data = [0, 0, 0, 0, 0, 0];
        this.barChartGraphData.datasets[1].data = [0, 0, 0, 0, 0, 0];
        this.barChartGraphData.datasets[2].data = [0, 0, 0, 0, 0, 0];
      } else {
        // Compliance (8) e Quality (12) seções
        this.barChartGraphData.datasets[0].data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        this.barChartGraphData.datasets[1].data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        this.barChartGraphData.datasets[2].data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      }
    },

    getDashboard() {
      this.isLoading = true;
      const filter = `fiscal_year=${this.fiscal_year}&rqr_type=${this.rqr_type}&profile=${this.currentProfile}&reference=${this.reference}`;

      this.$api.request
        .get(`dashboard?${filter}`)
        .then((response) => {
          const data = response.data;
          this.actionPlans = data.actionPlans;
          this.pending = data.pending;
          this.completed = data.completed;
          this.barChartGraphData.labels = this.labels;
          this.overallGraphData.data = [
            data.overallPieChart.compliant,
            data.overallPieChart.adequate,
            data.overallPieChart.unsatisfactory,
          ];
          this.standardGraphData.data = [
            data.standardPieChart.compliant,
            data.standardPieChart.adequate,
            data.standardPieChart.unsatisfactory,
          ];

          const sections = this.getSections();
          this.clearStandardBarChart();
          data.standardBarChart.forEach((standard) => {
            Object.keys(sections).forEach((section) => {
              const order = sections[section].order;

              if (standard.section === section) {
                this.barChartGraphData.datasets[0].data[order] = standard.compliant;
                this.barChartGraphData.datasets[1].data[order] = standard.adequate;
                this.barChartGraphData.datasets[2].data[order] = standard.unsatisfactory;
              }
            });
          });

          this.updateDatasetLabels();
        })
        .finally(() => (this.isLoading = false));
    },

    updateDatasetLabels() {
      if (this.rqr_type == 4) {
        this.barChartGraphData.datasets[0].label = "No Recommendation Needed";
        this.barChartGraphData.datasets[1].label = "Recommendation Needed";
        this.barChartGraphData.datasets[2].label = "";
        this.standardGraphData.labels = ["No Recommendation Needed", "Recommendation Needed", ""];
        this.overallGraphData.labels = ["No Recommendation Needed", "Recommendation Needed", ""];
      } else {
        this.barChartGraphData.datasets[0].label = "Compliant";
        this.barChartGraphData.datasets[1].label = "Adequate with exception";
        this.barChartGraphData.datasets[2].label = "Unsatisfactory";
        this.standardGraphData.labels = ["Compliant", "Adequate with exception", "Unsatisfactory"];
        this.overallGraphData.labels = ["Compliant", "Adequate with exception", "Unsatisfactory"];
      }
    },

    getReferences() {
      this.$api.request("all/advisories").then((response) => {
        this.references = response.data;
      });
    },

    getSections() {
      if (this.rqr_type == rqrTypeEnum.COMPLICE) {
        return {
          ecr_client_acceptance: {
            compliant: 0,
            adequate: 0,
            unsatisfactory: 0,
            order: 0,
          },
          independence: {
            compliant: 0,
            adequate: 0,
            unsatisfactory: 0,
            order: 1,
          },
          engagement_acceptance: {
            compliant: 0,
            adequate: 0,
            unsatisfactory: 0,
            order: 2,
          },
          higher_risk_engagements: {
            compliant: 0,
            adequate: 0,
            unsatisfactory: 0,
            order: 3,
          },
          contracting: {
            compliant: 0,
            adequate: 0,
            unsatisfactory: 0,
            order: 4,
          },
          deliverables_and_disclaimers: {
            compliant: 0,
            adequate: 0,
            unsatisfactory: 0,
            order: 5,
          },
          documentation: {
            compliant: 0,
            adequate: 0,
            unsatisfactory: 0,
            order: 6,
          },
          performance_and_review: {
            compliant: 0,
            adequate: 0,
            unsatisfactory: 0,
            order: 7,
          },
        };
      } else if (this.rqr_type == 4) {
        return {
          client: {
            compliant: 0,
            adequate: 0,
            unsatisfactory: 0,
            order: 0,
          },
          contract: {
            compliant: 0,
            adequate: 0,
            unsatisfactory: 0,
            order: 1,
          },
          value_proposition: {
            compliant: 0,
            adequate: 0,
            unsatisfactory: 0,
            order: 2,
          },
          talent: {
            compliant: 0,
            adequate: 0,
            unsatisfactory: 0,
            order: 3,
          },
          delivery: {
            compliant: 0,
            adequate: 0,
            unsatisfactory: 0,
            order: 4,
          },
          finance: {
            compliant: 0,
            adequate: 0,
            unsatisfactory: 0,
            order: 5,
          },
        };
      } else {
        return {
          clear_scope: {
            compliant: 0,
            adequate: 0,
            unsatisfactory: 0,
            order: 0,
          },
          engaged_stakeholders: {
            compliant: 0,
            adequate: 0,
            unsatisfactory: 0,
            order: 1,
          },
          governance_enabled: {
            compliant: 0,
            adequate: 0,
            unsatisfactory: 0,
            order: 2,
          },
          focused_benefits_management: {
            compliant: 0,
            adequate: 0,
            unsatisfactory: 0,
            order: 3,
          },
          managed_risks: {
            compliant: 0,
            adequate: 0,
            unsatisfactory: 0,
            order: 4,
          },
          smart_financing: {
            compliant: 0,
            adequate: 0,
            unsatisfactory: 0,
            order: 5,
          },
          delivery_enabling_plans: {
            compliant: 0,
            adequate: 0,
            unsatisfactory: 0,
            order: 6,
          },
          active_quality: {
            compliant: 0,
            adequate: 0,
            unsatisfactory: 0,
            order: 7,
          },
          agile_change_control: {
            compliant: 0,
            adequate: 0,
            unsatisfactory: 0,
            order: 8,
          },
          integrated_suppliers: {
            compliant: 0,
            adequate: 0,
            unsatisfactory: 0,
            order: 9,
          },
          high_performing_teams: {
            compliant: 0,
            adequate: 0,
            unsatisfactory: 0,
            order: 10,
          },
          embedded_lifecycle: {
            compliant: 0,
            adequate: 0,
            unsatisfactory: 0,
            order: 11,
          },
        };
      }
    },

    goToReviews(status = false) {
      const profile = this.currentProfile;
      const rqr_type = this.rqr_type;
      const fiscal_year = this.fiscal_year;
      this.$router.push({
        name: "Reviews",
        query: { status, profile, rqr_type, fiscal_year },
      });
    },

    goToActionPlans(status) {
      this.$router.push({ name: "Action Plans", query: { status } });
    },
  },
};
</script>
